import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-links">
          <Link to="/about" className="site-footer-link">
            About Us
          </Link>
          <Link to="/privacy" className="site-footer-link">
            Privacy Policy
          </Link>
          <Link to="/terms" className="site-footer-link">
            Terms of Service
          </Link>
          <a href="mailto:support@coinspire.com" className="site-footer-link">
            Contact
          </a>
        </div>

        <div className="site-footer-divider" />

        <div className="site-footer-disclaimer">
          <p>
            Trading involves risk. Digital asset markets are volatile. Past performance does not
            guarantee future results.
          </p>
        </div>

        <div className="site-footer-copy">
          <p>© {currentYear} Coinspire. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;